export default {
  data() {
    return {
      //row 1
      dashboardDoctorTime: '',
      dashboardDoctorTimeInterval: null,
      dashboardDoctorConsultantMissionCount: null,
      dashboardDoctorCallsCount: null,
      dashboardDoctorResponseTimeAverage: null,
      //row 2
      //pie chart
      dashboardDoctorPieChartOptions: {
        colors: [
          '#FF7600',
          '#007D83',
          '#002E91',
          '#D69415',
          '#C66512',
          '#0CC881',
          '#4986FF',
          '#FFB528',
          '#FF6925',
          '#02F4FF',
          '#1A63FF',
          '#FFA900',
        ],
        chart: {
          renderTo: 'dashboardDoctorPieChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'نتیجه تماس ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //column drug chart
      dashboardDoctorColumnDrugChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#6CBB5F',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'دارو',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
      //row 3
      //column diagnosis chart
      dashboardDoctorColumnDiagnosisChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#2EBA7F',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'تشخیص',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    readyDotorDashboard: function (data) {
      //row 1
      let duration = Math.round(data.workingHours.valueDouble);
      duration = duration * 1000;
      this.dashboardDoctorTimeInterval = setInterval(() => {
        duration = duration + 1000;
        this.dashboardDoctorTime = this.msToTime(duration);
      }, 1000);
      this.dashboardDoctorConsultantMissionCount = data.consultantMissions.valueLong;
      this.dashboardDoctorCallsCount = data.callsCount.valueLong;
      let duration2 = Math.round(data.responseTimeAverage.valueDouble);
      duration2 = duration2 * 1000;
      this.dashboardDoctorResponseTimeAverage = this.msToTime(duration2);
      //row 2
      //pie chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.callsTag));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.dashboardDoctorPieChartOptions.series[0].data = [];
      this.dashboardDoctorPieChartOptions.series[0].data = pieChartData;
      //column drug chart
      let coluumnDrugChartData = JSON.parse(JSON.stringify([]));
      let coluumnDrugTempArray = JSON.parse(JSON.stringify([]));
      coluumnDrugTempArray = JSON.parse(JSON.stringify(data.drugs));
      for (let i = 0; i < coluumnDrugTempArray.length; i++) {
        coluumnDrugChartData.push({
          name: coluumnDrugTempArray[i].title,
          y: coluumnDrugTempArray[i].valueLong,
          text: coluumnDrugTempArray[i].valueLong.toString(),
        });
      }
      coluumnDrugChartData = JSON.parse(JSON.stringify(coluumnDrugChartData));
      this.dashboardDoctorColumnDrugChartOptions.series[0].data = [];
      this.dashboardDoctorColumnDrugChartOptions.series[0].data = coluumnDrugChartData;
      //column drug chart
      let coluumnDiagnosisChartData = JSON.parse(JSON.stringify([]));
      let coluumnDiagnosisTempArray = JSON.parse(JSON.stringify([]));
      coluumnDiagnosisTempArray = JSON.parse(JSON.stringify(data.diagnoses));
      for (let i = 0; i < coluumnDiagnosisTempArray.length; i++) {
        coluumnDiagnosisChartData.push({
          name: coluumnDiagnosisTempArray[i].title,
          y: coluumnDiagnosisTempArray[i].valueLong,
          text: coluumnDiagnosisTempArray[i].valueLong.toString(),
        });
      }
      coluumnDiagnosisChartData = JSON.parse(JSON.stringify(coluumnDiagnosisChartData));
      this.dashboardDoctorColumnDiagnosisChartOptions.series[0].data = [];
      this.dashboardDoctorColumnDiagnosisChartOptions.series[0].data = coluumnDiagnosisChartData;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
